import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import DataSchema from './data-schema';
import UiSchema from './ui-schema';
import SemanticForm from '../../ui/semantic-form';

import { withRouter } from 'react-router-dom';

import { Container } from 'semantic-ui-react';

import { graphql } from 'react-apollo';
import UserQuery from '../../../graphql/queries/user.graphql';
import UpdateUserSignupMutation from '../../../graphql/mutations/update-user-signup.graphql';

@graphql(UserQuery, { name: 'user' })
@graphql(UpdateUserSignupMutation, { name: 'updateUser' })
@withRouter
export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
      }
    };
  }

  static propTypes = {
    history: PropTypes.object.isRequired
  }

  render() {
    const { user } = this.props.user;

    if (this.props.user.loading) {
      return null;
    }

    if (!user) {
      this.props.history.replace('/');
      return null;
    }

    return (
      <Container>
        <SemanticForm
          schema={DataSchema}
          uiSchema={UiSchema}
          formData={this.state.formData}
          onChange={this._onChange}
          onSubmit={this._onSubmit}
          onError={(args) => { console.log('errors', args); }} />
      </Container>
    );
  }

  _onChange = ({ formData }) => {
    this.setState({ formData });
  }

  _onSubmit = () => {
    const { user } = this.props.user;
    const { formData } = this.state;

    const variables = _.assign(
      {
        id: user.id,
        name: `${formData.firstName} ${formData.lastName}`
      },
      formData
    );

    this.props.updateUser({ variables })
      .then(() => {
        this.props.history.replace('/payment');
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/container/signup/index.js